import { setCookie, monthTimeout, getCookie } from '../../../helpers/cookie';

const getSberUrl = (orderId, preferredPayMethod) => {
  if (!orderId) {
    return;
  }

  let payMethod = preferredPayMethod || getCookie('PAYMENT_METHOD') || 'card';

  const data = {
    'order-id': orderId,
    'pay-method': payMethod,
  };

  if (payMethod === 'pushkin_card') {
    const fio = getCookie('PUSHKIN_FIO');

    if (fio) {
      data.fio = fio;
    } else {
      payMethod = 'card';
      data['pay-method'] = payMethod;
    }
  }

  const headers = {
    method: 'POST',
    body: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
    },
  };

  const route = '/local/php_interface/api/v2/payment/pay/';

  fetch(route, headers)
    .then(response => response.json())
    .then(json => {
      if (json.status === 'success') {
        if (json.data.redirect_url !== '') {
          setCookie('UNPAID_ORDER', 'TRUE');
          setCookie('PAYMENT_LINK', json.data.redirect_url);
          setCookie('PAYMENT_METHOD', payMethod);
          setCookie('userChooseInfo', 0, monthTimeout);
        }
      }
    })
    .catch(error => {
      console.error(error);
    });
};

export default getSberUrl;
